import { render } from "./temperature.vue?vue&type=template&id=207e87e2&scoped=true"
import script from "./temperature.vue?vue&type=script&lang=js"
export * from "./temperature.vue?vue&type=script&lang=js"

import "./temperature.vue?vue&type=style&index=0&id=207e87e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207e87e2"]])

export default __exports__